import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';

/**
 * Renders a version count as "N versions". The latest version string is not
 * carried on the grouped software row, so it is shown in the drill-down panel
 * rather than here.
 */
const VersionsCellRenderer: React.FC<ICellRendererParams> = ({ value }) => {
    const count = typeof value === 'number' ? value : Number(value) || 0;
    return (
        <span className="inventory-versions-cell">
            <span className="inventory-versions-cell__count">{count}</span>
            <span className="inventory-versions-cell__unit">{count === 1 ? 'version' : 'versions'}</span>
        </span>
    );
};

export default VersionsCellRenderer;
